module.exports = require('./helpers/bundle-url').getBundleURL('jZAn8') + "logo.c51670a8.svg";